import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            玩家口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            万千玩家的共同选择
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            听听真实用户怎么说，他们的故事就是最好的证明。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="p-5 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-accent-600">{t.achievement}</div>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(t.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.comment}</p>
              <div className="mt-3 text-xs text-foreground-500">{t.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}